module.exports = __webpack_public_path__ + "map-pin.svg";